<template>
  <v-container v-if="userIsAuthenticated">
    <v-layout row wrap>
      <v-flex xs12>
        <a @click="$router.go(-1)" style="cursor:pointer" class="page_backspace"><v-icon class="mr-1">keyboard_backspace</v-icon> Назад </a>
        <v-card class="v-card_layout">
          <v-card-text>
            <v-card-text>
              <youtube :video-id='meetup.youtube'  :player-vars="playerVars" @playing="playing"></youtube>
              <div class="page_inner__category"><v-icon class="mr-1">bookmark</v-icon>{{  meetup.youtube }}  </div>
              <p class="headline text--primary">{{  meetup.title }}</p>
              <p><b>автор:</b> {{ meetup.author }} <br><b>район:</b> {{ meetup.region }}</p>
              <div>{{ meetup.description }}</div>
            </v-card-text>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <app-meetup-register-dialog
              :meetupId="meetup.id">
            </app-meetup-register-dialog>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
  <v-layout v-else>
    <v-flex  v-if="loading">
      <v-row justify="center">
        <v-flex xs12 class="text-xs-center" mt-3 >
          <v-progress-circular indeterminate color="red"></v-progress-circular>
        </v-flex>
      </v-row>
    </v-flex>
    <v-flex xs12 class="text-xs-center" mt-5 v-else>
      <router-link to="/" tag="span" style="cursor: pointer"><v-btn class="a_btn_accept text" >Авторизируйтесь</v-btn></router-link>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['id'],
  data () {
      return {
        playerVars: {
            autoplay: 0
        }
      }
    },
  methods: {
    playVideo() {
      this.player.playVideo()
    },
    playing() {
        console.log('\o/ we are watching!!!')
        }
    },
  computed: {
    meetup () {
      return this.$store.getters.loadedMeetup(this.id)
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    userIsCreator () {
      if (!this.userIsAuthenticated) {
        return false
      }
      return this.$store.getters.user.id === this.meetup.creatorId
    },
    loading () {
      return this.$store.getters.loading
    },
     player() {
        return this.$refs.youtube.player
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Meetup/Meetup.vue